<template>
  <modal :show="show" @close="close">
    <div slot="modalHeader">
      <modal-header :closeModal="close">Edit Invoice Number</modal-header>
    </div>
    <form-group>
      <field v-if="invoice" v-model="externalId"></field>
    </form-group>
    <div slot="modalFooter">
      <modal-footer :closeModal="close" :confirm="savePost"/>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import FormGroup from '@/components/Form/FormGroup/form-group'
import Field from '@/components/Form/Field/field'

import {invoiceMixin} from '@/mixins/invoiceMixin'
import {modalMixin} from '@/mixins/modalMixin'
import {notificationMixin} from '@/mixins/notificationMixin'

export default {
  name: 'modal_invoice_number',
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta,
    FormGroup,
    Field
  },
  mixins: [invoiceMixin, modalMixin, notificationMixin],
  props: {
    show: Boolean
  },
  data: () => ({
    externalId: null
  }),
  created () {
    if (this.invoice) {
      this.externalId = this.invoice.external_id
    }
  },
  computed: {},
  methods: {
    savePost () {
      const data = {
        invoiceId: this.invoiceNumber,
        status: this.invoice.status,
        external_id: this.externalId
      }
      this.startLoading()
      this.updateInvoice(data).then(() => {
        this.getSingleInvoice(this.invoiceNumber).then(() => {
          this.finishLoading()
          this.addNotification('success', 'Invoice number updated.')
        }, error => {
          this.finishLoading()
          this.addNotification('danger', error)
        })
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
      this.close()
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Modal/invoices/modal-invoice-number.vue